// extracted by mini-css-extract-plugin
export default {"titleBox":"Accordian_titleBox__Q434m","body":"Accordian_body__SUQFn","title":"Accordian_title__snqgF","text":"Accordian_text__GOCIB"};